export const savingOpportunitiesDefaultHiddenColumns = new Set([
  "description",
  "cloud_provider",
  "resource_type",
  "recommended_type",
  "resource_id",
  "resource_arn",
  "based_on_past",
  "region",
  "tags",
  "current_monthly_price",
  "estimated_monthly_price",
  "task",
]);
